var _rect, _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProduto(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 41,
    viewBox: "0 0 42 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 42,
    height: 40,
    rx: 6.72,
    fill: "url(#paint0_linear_864_850)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.6 16.9V14.2L27.3 11.5L28.2 13.3L30 14.2L27.3 16.9H24.6ZM24.6 16.9L21 20.5M30 20.5C30 25.4706 25.9706 29.5 21 29.5C16.0294 29.5 12 25.4706 12 20.5C12 15.5294 16.0294 11.5 21 11.5M25.5 20.5C25.5 22.9853 23.4853 25 21 25C18.5147 25 16.5 22.9853 16.5 20.5C16.5 18.0147 18.5147 16 21 16",
    stroke: "white",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_864_850",
    x1: -1.9677e-7,
    y1: 1,
    x2: 80,
    y2: 69,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0875,
    stopColor: "#0575E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.847875,
    stopColor: "#02298A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#021B79"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProduto);
export default __webpack_public_path__ + "static/media/Produto.edfea80f7e74194da5bedef73174d4c3.svg";
export { ForwardRef as ReactComponent };